<template>
  <v-card color_="blue-grey darken-2" class_="white--text" class="elevation-2">
    <v-card-title primary-title class_="blue-grey darken-2">
      <div class="subheading font-weight-medium mb-2">Relatório de Pagamentos - Empresas e Setores</div>
      <div>Relação dos pagamentos efetuados agrupados por Empresas e Setores.</div>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn small text color="primary" @click="aberto = !aberto">{{ aberto ? 'Cancelar' : 'Opções'}}</v-btn>
    </v-card-actions>
    <v-divider v-show="aberto"></v-divider>
    <v-slide-y-transition>
    <v-card-text v-show="aberto" class="white">
      <v-layout row wrap>
        <v-flex>
          <z-date-picker-menu label="Data Inicial" v-model="filtro.data_inicial" ></z-date-picker-menu>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <z-date-picker-menu label="Data Final" v-model="filtro.data_final"></z-date-picker-menu>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex sm12>
          <v-autocomplete v-model="filtro.empresasolicitante_id" placeholder=" " label="Empresa Solicitante"  hint="Opcional" persistent-hint flat :items="$store.getters['listas/empresassolicitantes']" clearable></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>
      </v-slide-y-transition>
    <v-divider ></v-divider>
    <v-card-actions class="white" v-show="aberto">
      <v-spacer></v-spacer>
      <v-btn  icon v-show="aberto" @click="imprimir">
        <v-icon>print</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import qs from "qs";
import config from "../../app/config";
  export default {
    data () {
      return {
        aberto: false,
        filtro: {
          data_inicial: this.$moment().format('YYYY-MM-DD'),
          data_final: this.$moment().format('YYYY-MM-DD'),
          empresasolicitante_id: null,
        }
      }
    },

    methods: {
      imprimir() {
        if (config.IS_PRODUCTION) {
          this.abrirJanela(window.location.origin + '/relatorios/pagamentos/empresasetores?'+ qs.stringify(this.filtro));
        } else {
          this.abrirJanela('http://localhost:8001/relatorios/pagamentos/empresasetores?'+ qs.stringify(this.filtro));
        }
      },
    }
  }
</script>

<style scoped>

</style>